import { NgModule } from "@angular/core";
import {
  Activity,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Ban,
  Building2,
  ChartColumn,
  Check,
  ChevronDown,
  ChevronFirst,
  ChevronLast,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  CircleAlert,
  CircleCheckBig,
  CircleX,
  Clock,
  ClockPlus,
  Download,
  Eye,
  EyeOff,
  ExternalLink,
  FileText,
  Lock,
  LockKeyhole,
  LogIn,
  LucideAngularModule,
  Mail,
  MailPlus,
  Pill,
  Play,
  Plus,
  Save,
  Scissors,
  Search,
  Send,
  Settings,
  SquarePen,
  Upload,
  User,
  UserMinus,
  UserPen,
  UserPlus,
  Users,
  X,
} from "lucide-angular";

@NgModule({
  imports: [
    LucideAngularModule.pick({
      Activity,
      ArrowDown,
      ArrowLeft,
      ArrowRight,
      ArrowUp,
      Ban,
      Building2,
      ChartColumn,
      Check,
      ChevronDown,
      ChevronFirst,
      ChevronLast,
      ChevronLeft,
      ChevronRight,
      ChevronUp,
      CircleAlert,
      CircleCheckBig,
      CircleX,
      Clock,
      ClockPlus,
      Download,
      Eye,
      EyeOff,
      ExternalLink,
      FileText,
      Lock,
      LockKeyhole,
      LogIn,
      Mail,
      MailPlus,
      Pill,
      Play,
      Plus,
      UserPlus,
      Save,
      Scissors,
      Search,
      Send,
      Settings,
      SquarePen,
      Upload,
      User,
      UserMinus,
      UserPen,
      Users,
      X,
    }),
  ],
  exports: [LucideAngularModule],
})
export class IconsModule {}
